<template>
  <div class="flex-col org-main"
    :class="{news: newsType==0 ,market:newsType==1 }">
    <div class="cont-list"
      v-if="newsType==0">
      <van-list v-model="news.loading"
        :finished="news.finished"
        finished-text="没有更多了"
        @load="onLoad">
        <div v-for="item in news.itemList"
          :key="item.id">
          <div class="flex-col item-info"
            @click="goNewsDetail(item.id)">

            <label class="news-title"
              v-html="item.newsTitle"></label>
            <div class="flex-row news-info">
              <label>{{ $t('newsFrom') }}{{item.domain}}</label>
              <label>{{ item.publishDate}}</label>
            </div>
          </div>
          <div class="split-info" />
        </div>
      </van-list>
    </div>
    <div class="cont-list"
      v-if="newsType==1">
      <van-list v-model="marketNews.loading"
        :finished="marketNews.finished"
        finished-text="没有更多了"
        @load="onLoad"
        :offset="offset">
        <div v-for="item in marketNews.itemList"
          :key="item.id">
          <div class="flex-col item-info"
            @click="goNewsDetail(item.id)">
            <label class="news-title"
              v-html="item.newsTitle"></label>
            <div class="flex-row news-info">
              <label>{{item.newsFrom}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.industry}}</label>
              <label>{{ item.createTime}}</label>
            </div>
          </div>
          <div class="split-info" />
        </div>
      </van-list>
    </div>

    <div class="cont-list"
      v-if="newsType==2 || newsType==3">
      <van-list v-model="marketNews.loading"
        :finished="marketNews.finished"
        finished-text="没有更多了"
        @load="onLoad">
        <div v-for="item in marketNews.itemList"
          :key="item.id">
          <div class="flex-row collect"
            @click="goNewsDetail(item.id)">
            <div class="flex-col item-info">
              <label class="news-title"
                v-html="item.newsTitle"></label>
              <div class="flex-row news-info">
                <label>{{ $t('newsFrom') }}{{item.newsFrom}}</label>
                <label>{{ item.createTime}}</label>
              </div>
            </div>
            <div v-show="isEdit"
              style="width:40px;min-width: 40px;">
              <van-checkbox v-model="item.checked"
                checked-color="#c52a1a"></van-checkbox>
            </div>
          </div>
          <div class="split-info" />
          <div v-if="refreshView"></div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import common from "@common/common";
import webService from "@network/webService";
export default {
  name: "",
  props: {
    newsType: {
      type: Number,
      default: 0,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      offset: 20,
      OrderType: 2,
      searchType: null,
      searchPeriod: 0,
      searchValue: "",
      news: {
        itemList: [],
        loading: false,
        finished: false,
        currentPage: 0,
      },
      marketNews: {
        itemList: [],
        loading: false,
        finished: false,
        currentPage: 0,
      },
      refreshView: false,
    };
  },
  created () {
    console.log('newsType' + this.newsType);
    if (this.newsType == 2 || this.newsType == 3) {
      this.loadData(2);
    }
  },
  mounted () { },
  methods: {
    loadData (type) {
      this.news.itemList = [];
      this.news.loading = false;
      this.news.currentPage = 0;
      this.marketNews.itemList = [];
      this.marketNews.loading = false;
      this.marketNews.currentPage = 0;
      this.OrderType = type;
      this.onLoad();
    },
    onLoad () {
      if (this.newsType == 0) {
        this.requestPageData(this.news, true);
      } else if (this.newsType == 2) {
        this.requestPageData(this.marketNews, true);
      } else if (this.newsType == 3) {
        this.requestPageData(this.marketNews, true);
      } else {
        this.requestPageData(this.marketNews, true);
      }
    },
    requestPageData (obj, isAdd) {

      var param = {
        PageSize: 20,
        Page: obj.currentPage,
        Search: this.searchValue,
        OrderType: this.OrderType,
        SearchType: this.searchType,
        SearchPeriod: this.searchPeriod,
      };
      obj.loading = true;
      if (this.newsType == 0) {
        webService.getNewsList(param).then((res) => {

          //搜索模块需要高亮
          if (
            !_.isEmpty(this.searchValue) &&
            this.searchValue.length > 0
          ) {
            this.hightLightNews(res.data, this.searchValue);
          }
          this.processData(obj, res.data, isAdd);
        });
      } else if (this.newsType == 1) {
        webService.getMargetNewsList(param).then((res) => {

          //搜索模块需要高亮
          if (
            !_.isEmpty(this.searchValue) &&
            this.searchValue.length > 0
          ) {
            this.hightLightNews(res.data, this.searchValue);
          }
          this.processData(obj, res.data, isAdd);
        });
      } else if (this.newsType == 2) {
        webService.GetFavoriteMarketIntelligence(param).then((res) => {
          this.processData(obj, res.data, isAdd);
        });
      } else if (this.newsType == 3) {
        webService.GetHistoryMarketIntelligence(param).then((res) => {
          this.processData(obj, res.data, isAdd);
        });
      }
    },
    processData (obj, data, isAdd) {
      data.forEach((e) => {
        if (e.publishDate) {
          e.publishDate = this.$moment(e.publishDate).format(
            "DD/MM/YYYY"
          );
        }
        if (e.createTime) {
          e.createTime = this.$moment(e.createTime).format(
            "DD/MM/YYYY"
          );
        }
        e.checked = false;
      });
      if (isAdd) {
        for (let i = 0; i < data.length; i++) {
          obj.itemList.push(data[i]);
        }
      } else {
        obj.itemList = data;
      }
      obj.loading = false;
      if (data.length <= 0) {
        obj.finished = true;
      }
      else {
        obj.finished = false;
      }
      obj.currentPage++;
    },
    goNewsDetail (id) {
      if (this.newsType == 0) {
        this.$router.push({
          path: "/newsDetail",
          query: {
            id: id,
            type: this.newsType,
          },
        });
      } else if (this.newsType == 2 || this.newsType == 3) {

        if (!this.isEdit) {
          this.$router.push({
            path: "/newsMarket",
            query: {
              id: id,
            },
          });
        }
      } else {
        this.$router.push({
          path: "/newsMarket",
          query: {
            id: id,
          },
        });
      }
    },
    searchData (searchParam) {

      if (
        searchParam.searchPeriod &&
        searchParam.searchPeriod.length > 0
      ) {
        this.searchPeriod = parseInt(searchParam.searchPeriod[0]);
      } else {
        this.searchPeriod = 0;
      }

      if (this.newsType == 0) {
        this.searchType = searchParam.newsTypeString;
        // this.searchPeriod = 0;
        this.news.currentPage = 0;
        this.requestPageData(this.news, false);
      } else {
        this.searchType = null;

        this.marketNews.currentPage = 0;
        this.requestPageData(this.marketNews, false);
      }
    },
    searchNews (searchValue) {
      this.searchValue = searchValue;
      this.news.currentPage = 0;
      this.requestPageData(this.news, false);
    },
    searchMarket (searchValue) {

      this.searchValue = searchValue;
      this.marketNews.currentPage = 0;
      this.requestPageData(this.marketNews, false);
    },
    hightLightNews (marketList, search) {
      if (
        marketList.length > 0 &&
        !_.isEmpty(search) &&
        search.length > 0
      ) {
        let searchArray = _.split(search, " ");
        searchArray.forEach((e) => {
          let searchItem = e;
          let replaceReg = new RegExp(searchItem, "g"); // 匹配关键字正则
          let replaceString =
            '<span style="color:#c52a1a">' + searchItem + "</span>"; // 高亮替换v-html值
          marketList.forEach((e) => {
            //e.newsTitle = this.$options.filters['ellipsis'](e.newsTitle, 80);
            e.newsTitle = e.newsTitle.replace(
              replaceReg,
              replaceString
            ); // 开始替换
          });
        });
      }
    },
    selectAll () {
      this.marketNews.itemList.forEach((element) => {
        element.checked = true;
      });
      this.refreshView = !this.refreshView;
    },
    cancelSelected () {
      this.marketNews.itemList.forEach((element) => {
        element.checked = false;
      });
      this.refreshView = !this.refreshView;
    },
    deleteItem () {
      console.log(this.marketNews)
      common.batchDeleteMarked_News(this.marketNews);
    },
    cancelMark (id) {
      common.cancelMark(this.marketNews.itemList, id);
    },
    changeSearchValue (value) {
      this.searchValue = value;
    }
  },
};
</script>

<style lang='scss' scoped>
.org-main {
  border-top: 1px solid #dedede;
  height: 100%;
  // height: calc(100% - 110px);
}
.news {
  height: calc(100% - 110px);
}
.market {
  height: calc(100% - 110px);
}
.cont-list {
  height: 100%;
  overflow: auto;
  flex: 1;
}
.news-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 1rem;
  max-height: 40px;
  overflow: hidden;
}
.news-info {
  font-size: 12px;
  justify-content: space-between;
  color: #7d7d7d;
}
.collect {
  //width:80%;
  align-items: center;
  justify-content: space-between;
}
.split-info {
  height: 5px;
}
.item-info {
  width: 100%;
  padding: 1rem;
}

.div-chk {
  // position: absolute;
  // right: 15px;
  // transform: translateY(-300%);
}
</style>


// WEBPACK FOOTER //
// src/views/overview/NewsList.vue